







































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { SystemCode } from '@/api'

export interface ReserveSetGroupEditTableItem {
  isSelected: boolean
  isNewAddReserve: boolean
  id: number
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SearchType
  reserveSetRank: number
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  collectionFlag: CollectionFlag
  reserveStatus: SystemCode
  revision: number
}

@Component({
  components: { IconBibliography, DataTable }
})
export default class ReserveSetGroupEditTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: ReserveSetGroupEditTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  rank!: boolean

  @Prop({
    type: Number,
    required: true
  })
  activeRowIndex!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isAllSelect!: boolean

  get cols(): Col[] {
    const cols: Col[] = [
      {
        width: 26,
        items: [
          {
            name: 'check',
            headerText: '',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            headerText: this.rank ? '順位' : '',
            align: 'right'
          }
        ]
      },
      {
        width: '14',
        resizable: true,
        items: [
          {
            name: 'bibliographyRealId',
            headerText: '書誌番号'
          }
        ]
      },
      {
        width: '33',
        resizable: true,
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayAuthor',
            headerText: '責任表示'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayPublisher',
            headerText: '出版者'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displaySize',
            headerText: '大きさ'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayPublished',
            headerText: '出版年'
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'reserveStatus',
            headerText: '予約状態'
          }
        ]
      }
    ]

    if (this.rank) {
      cols.push({
        width: 140,
        items: [
          {
            name: 'rank',
            align: 'center'
          }
        ]
      })
    }

    cols.push({
      width: 30,
      items: [
        {
          name: 'remove',
          align: 'center'
        }
      ]
    })

    return cols
  }

  bibliographyId(item: ReserveSetGroupEditTableItem) {
    if (item.bibliographyRealId === 0) {
      return ''
    }

    return item.prefix + item.bibliographyRealId.toString().padStart(10, '0')
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  movableUp(value: ReserveSetGroupEditTableItem): boolean {
    const index = this.items
      .filter(item => item.reserveStatus.code === '4' || item.isNewAddReserve)
      .findIndex(item => item.bibliographyRealId === value.bibliographyRealId)

    return (
      index !== 0 && (value.reserveStatus.code === '4' || value.isNewAddReserve)
    )
  }

  movableDown(value: ReserveSetGroupEditTableItem): boolean {
    const index = this.items
      .filter(item => item.reserveStatus.code === '4' || item.isNewAddReserve)
      .findIndex(item => item.bibliographyRealId === value.bibliographyRealId)

    return (
      index !==
        this.items.filter(
          item => item.reserveStatus.code === '4' || item.isNewAddReserve
        ).length -
          1 &&
      (value.reserveStatus.code === '4' || value.isNewAddReserve)
    )
  }

  onClickUp(index: number) {
    const tempRank = this.items[index].reserveSetRank
    this.items[index].reserveSetRank = this.items[index - 1].reserveSetRank
    this.items[index - 1].reserveSetRank = tempRank

    this.items.splice(index - 1, 2, this.items[index], this.items[index - 1])
  }

  onClickDown(index: number) {
    const tempRank = this.items[index].reserveSetRank
    this.items[index].reserveSetRank = this.items[index + 1].reserveSetRank
    this.items[index + 1].reserveSetRank = tempRank

    this.items.splice(index, 2, this.items[index + 1], this.items[index])
  }

  @Emit('remove')
  onClickRemove(index: number): number {
    return index
  }

  @Emit('click:row')
  onClickRow(index: number): number {
    return index
  }

  @Emit('all-select')
  onAllSelect(): void {}
}
